import { Link } from "react-router-dom";

// Components
import LocationSelector from "./LocationSelector";

// MUI
import { Stack } from "@mui/material";

// Icons
import Logo from "@/assets/icons/header/logo";

export const HeaderLogoSection = () => {
	return (
		<Stack direction="row" className="h-full">
			<Link to="/dashboard" className="h-full">
				<Stack justifyContent="center" className="text-white h-full">
					<Logo />
				</Stack>
			</Link>
			<Stack className="bg-white w-[2px] h-[25px] my-auto ml-3" />
			<Stack className="ml-1 h-full">
				<LocationSelector />
			</Stack>
		</Stack>
	);
};
